var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('input',{staticClass:"form-control",attrs:{"id":_vm.uniqueId,"placeholder":_vm.$t('COMMON.START_TYPING_CITY_REGION_COUNTRY')},domProps:{"value":_vm.address}})])
}
var staticRenderFns = []

export { render, staticRenderFns }